@if (visible) {
    <a
        name="button"
        class="md:hide button phone m-12:b"
        href="tel:004962112476820"
        aria-label="Anrufen"
    ></a>
    <button
        name="button"
        class="hide md:block button phone m-12:b"
        [ngClass]="{ '-open': showPhoneNumber }"
        (click)="togglePhone()"
        (clickOutside)="closePhone()"
    >
        <span
            class="phone-expanded"
            (click)="$event.stopPropagation()"
            >+49 621 1247682-0</span
        >
    </button>
    <a
        name="button"
        class="button mail"
        [routerLink]="['kontakt']"
        aria-label="Kontakt"
    ></a>
}
